module.exports = __webpack_public_path__ + "static/media/professional_services.a38745b2.png";